import { Button } from '../../../components/Button';
import { ButtonGroup } from '../../../components/ButtonGroup';
import { Popup } from '../../../components/Popup';
import PopupStructure from '../../../components/PopupStructure';
import PopupTitleDangerous from '../../../components/PopupTitleDangerous';
import styles from "../StudioPage/Studio.module.css";

export interface IStudioChannelPopupDelete {
  onClose: () => void;
  isShow: boolean;
  channelName?: string;
  onDelete:() => void;
};

const StudioChannelPopupDelete = ({ isShow, onClose, channelName, onDelete }: IStudioChannelPopupDelete) => {
  return (
    <Popup isShow={isShow} onClose={onClose}>
      <PopupStructure
        headerComponent={<PopupTitleDangerous>Предупреждение</PopupTitleDangerous>}
        contentComponent={
          <div className={styles['page__popup-description']}>
            Вы уверены, что хотите удалить канал “{channelName}”?
          </div>
        }
        footerComponent={
          <ButtonGroup>
            <Button kind="secondary" onClick={onDelete}>Удалить</Button>
            <Button kind="primary" onClick={onClose}>Отмена</Button>
          </ButtonGroup>
        }
      />
    </Popup>
  );
};

export default StudioChannelPopupDelete;
